"use client";

import createIcon from './util/createIcon';
export default createIcon('M7,3H16.95V12.96L12.96,20.94H8L11.97,12.96H7V3Z', 'Comma');